const BUNDLE_LINK_PREFIX = "/a/loop_subscriptions/bundle";
const LOOP_BUNDLE_URL =
  "https://api-service.loopwork.co/bundleTransaction/getBundleCartDetails";
const LOOP_API_SERVICE_URL = "https://api-service.loopwork.co";

const getItemsHtml = (item) => {
  return `<p><span class="data-cart-item-selling-plan-name">${
    item.title || ""
  } x ${item.quantity || ""}</span></p>`;
};
const getBundleCartItemsTemplate = (bundleItem, index, bundleLink) => {
  return `
        <tr class="cart-item" id="CartBundleItem-${index}">
              <td class="cart-item__media" style="text-align:center;">
                <img class="cart-item__image" src="${
                  bundleItem.image || ""
                }" alt="${
    bundleItem.label
  }" loading="lazy" width="75" height="75">
              </td>
              <td class="cart-item__details">
                    <a href="${bundleLink}" class="cart-item__name break">${
    bundleItem.label || ""
  }</a><dl><div class="product-option">
                    ${bundleItem.items
                      .map((item) => {
                        return `<p style="display:block;">${
                          item.title || ""
                        } x ${item.quantity || ""}</p>`;
                      })
                      .join("")}
                    <br/><p><span class="data-cart-item-selling-plan-name">${
                      bundleItem.sellingPlan || ""
                    }</span></p>
              </td>

              <td class="cart-item__quantity">
                    ${bundleItem.quantity}
              </td>

              <td class="cart-item__totals right">
                <div class="cart-item__price-wrapper medium-up"><span class="price price--end">
                       <span class="hulkapps-cart-item-line-price">${
                         bundleItem.amount
                       }</span>
                       </span>
                  </div>

                  <div onclick="removeBundle('${
                    bundleItem.bundleId
                  }')" style="cursor:pointer; width: fit-content;height: 20px;display: inline-flex;flex-direction: row-reverse;">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                          <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                          <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                    </svg>
                  </div>
                
              </td>
            </tr>
    `;
};

const getItemKeysByBundleId = (bundleId) => {
  const cartItems = window.Loop.bundleCartAllItems;
  const data = {
    updates: {},
  };
  for (const item of cartItems) {
    const _bundleId = item?.properties?.bundleId;
    if (!_bundleId || _bundleId !== bundleId) continue;
    data.updates[item.key] = 0;
  }
  return data;
};

const removeBundle = async (bundleId) => {
  const data = getItemKeysByBundleId(bundleId);
  const endpoint = `${window.Shopify.routes.root}cart/update.js`;
  await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  window.location.href = window.location.href;
};

const _getSelectedBundleVariants = (bundleId) => {
  const _allBundleCartItems = window.Loop.bundleCartAllItems;
  let _selectedVariants = "";
  let _selectedQuantities = "";
  for (const _item of _allBundleCartItems) {
    const _bundleId = _item?.properties?.bundleId;
    if (!_bundleId || _bundleId !== bundleId) continue;
    _selectedVariants += `${_item.id},`;
    _selectedQuantities += `${_item.quantity},`;
  }
  return {
    selectedVariants: _selectedVariants.substring(
      0,
      _selectedVariants?.length - 1
    ),
    selectedQuantities: _selectedQuantities.substring(
      0,
      _selectedQuantities?.length - 1
    ),
  };
};

const _getLoopToken = async (shopifyDomain, bundleId) => {
  const _endpoint = `${LOOP_API_SERVICE_URL}/bundleTransaction/getToken?shopifyDomain=${shopifyDomain}&bundleTransactionId=${bundleId}`;
  const _response = await fetch(_endpoint);
  const _jsonRes = await _response.json();
  return _jsonRes?.token ?? "LOOP_TOKEN";
};

const editBundle = async (bundleId) => {
  console.log(`Editing bundle: ${bundleId}`);
  const { selectedVariants, selectedQuantities } = _getSelectedBundleVariants(
    bundleId
  );
  const _shopifyDomain = window?.Shopify?.shop;
  const _loopToken = await _getLoopToken(_shopifyDomain, bundleId);
  const _editBundleRef = `${BUNDLE_LINK_PREFIX}/change/${bundleId}?loop_token=${_loopToken}&selectedVariants=${selectedVariants}&selectedQuantities=${selectedQuantities}`;
  window.location.href = _editBundleRef;
};

const fetchBundleTransactionCartDetails = async (loopBundleGuid) => {
  const endpoint = `${LOOP_BUNDLE_URL}/${loopBundleGuid}`;
  const response = await fetch(endpoint);
  return await response.json();
};

const addExtraDetailsToBundleItems = async (bundleItems) => {
  for (let i = 0; i < bundleItems.length; ++i) {
    const extraDetails = await fetchBundleTransactionCartDetails(
      bundleItems[i].bundleId
    );
    bundleItems[i].label = extraDetails?.label;
    bundleItems[i].image = extraDetails?.image;
    bundleItems[i].sellingPlan = extraDetails?.name;
    bundleItems[i].price = `${extraDetails.currencySymbol}${parseFloat(
      bundleItems[i].price.toFixed(2)
    )}`;
    bundleItems[i].amount = `${extraDetails.currencySymbol}${parseFloat(
      bundleItems[i].amount.toFixed(2)
    )}`;
    bundleItems[i].loopBundleId = extraDetails.loopBundleId;
  }
};

const getBundleItems = (items) => {
  const bundleItemsMap = {};
  for (const item of items) {
    const bundleId = item?.properties?.bundleId;
    if (!bundleId || !/^([0-9a-f]{32}|[0-9A-Z]{26})$/.test(bundleId)) continue;
    if (!Object.hasOwn(bundleItemsMap, bundleId)) {
      bundleItemsMap[bundleId] = {
        bundleId,
        quantity: 1,
        price: (Number(item.price) * Number(item.quantity)) / 100,
        amount: (Number(item.price) * Number(item.quantity)) / 100,
        items: [item],
      };
    } else {
      bundleItemsMap[bundleId].price +=
        (Number(item.price) * Number(item.quantity)) / 100;
      bundleItemsMap[bundleId].amount +=
        (Number(item.price) * Number(item.quantity)) / 100;
      bundleItemsMap[bundleId].items.push(item);
    }
  }
  return Object.values(bundleItemsMap);
};

const renderBundleItems = (bundleItems) => {
  let parent = document.querySelectorAll(".cart-items-body");
  for (let i = 0; i < bundleItems.length; ++i) {
    const bundleLink = `${BUNDLE_LINK_PREFIX}/${bundleItems[i].loopBundleId}`;
    const template = getBundleCartItemsTemplate(
      bundleItems[i],
      i + 1,
      bundleLink
    );
    parent.forEach((ele) => {
      ele.innerHTML = `${template} ${ele.innerHTML}`;
    });
  }
};

const bootstrap = async () => {
  const cartItems = window.Loop.bundleCartAllItems;
  const bundleItems = getBundleItems(cartItems);
  await addExtraDetailsToBundleItems(bundleItems);
  renderBundleItems(bundleItems);
};

bootstrap();
